exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.spinner-container .spinner {\n  width: 3rem;\n  height: 3rem;\n  color: #4824bb;\n}", ""]);

// exports
